export default "__VITE_ASSET__BvZVdUJn__"